<div class="bonusDialog bonus-dialog">
  <h2
    mat-dialog-title
    class="bonus-dialog__title"
  >
    {{ bonus.name }}{{ (showBonusPoints) ? ' - ' + bonus.bonusValue + ' ' + translationService.getTranslation('order_bonusPoints') : '' }}
  </h2>
  <mat-dialog-content class="mat-typography bonus-dialog__content">
    @if (bonus.image) {
      <img class="bonusImg bonus-dialog__image"
           [ngSrc]="bonus?.image?.src"
           [width]="imageService.width"
           [height]="imageService.height"
           [alt]="bonus?.image?.altText" fitImage>
    }
    @if (!bonus.descriptionFromDocument) {
      <p
        [innerHTML]="bonus.description"
        class="bonus-dialog__description"
      ></p>
    }
    @if (bonus.descriptionFromDocument) {
      <p
        [innerHTML]="bonus.descriptionFromDocument"
        class="bonus-dialog__description"
      ></p>
    }

    @if (bonus.clientCoPayment > 0) {
      <p
        [innerHTML]="translationService.getTranslation('order_adjustment') + ' ' + bonus.clientCoPayment + ' ' + bonus.isoCurrencyCode"
        class="bonus-dialog__copayment"
      >
        <br/>
      </p>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="center" class="bonus-dialog__actions">
    <button
      mat-raised-button
      color="primary"
      mat-dialog-close=""
      data-cy="btn-bonus-details.close"
      [innerHTML]="translationService.getTranslation('button_close')"
      class="bonus-dialog__close-btn"
    ></button>
  </mat-dialog-actions>
</div>
